(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("KontentSmartLink", [], factory);
	else if(typeof exports === 'object')
		exports["KontentSmartLink"] = factory();
	else
		root["KontentSmartLink"] = factory();
})(window, function() {
return 